var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drag-wrap",style:({ top: _vm.top + 'px', left: _vm.left + 'px' }),on:{"touchstart":_vm.touchstart,"touchmove":_vm.touchmove}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }